<template>
  <div>
    <div v-if="inscription.gia.propose && !mainStore.inscription_as_admin">

      <GIA :item="inscription.gia" @changeGIA="update_cart('gia')"
        :initial_commande_inscription="initial_commande_inscription"></GIA>
    </div>

    <div v-if="inscription.alerte_sms.propose && !mainStore.inscription_as_admin">

      <AlerteSMSItem :item="inscription.alerte_sms" @changeAlerteSMS="update_cart('alerte_sms')"></AlerteSMSItem>
    </div>
    <DonationItem :item="inscription.donation" @changeDonation="update_cart('donation')"></DonationItem>
    <div v-if="initial_commande_inscription && initial_commande_inscription.list_commandes_options.length > 0">
      <div class="text-h6">Options/Activités conservées</div>
      <div class="text-body">Les options et activités suivantes seront conservées de votre première inscription, vous
        avez la possibilité d'en réserver davantage ci-dessous</div>
      <div class="d-flex flex-wrap">
        <InitialOptionItem v-for="option in initial_commande_inscription.list_commandes_options" :item="option"
          :key="option.id"></InitialOptionItem>
      </div>
    </div>
    <div v-if="inscription.list_options.list.length > 0">
      <div class="text-h6 mb-2">Options</div>
      <OptionItem v-for="(option, index) in inscription.list_options.list"
        :options_coureur="inscription.list_options.list" :initial_commande_inscription="initial_commande_inscription"
        :group_with_last="group_with_last(index)" :key="option.id" :item="option" :index_inscription="index_inscription"
        @updateQuantite="update_cart('options')"></OptionItem>
    </div>

    <div v-if="inscription.list_activites.list.length > 0">
      <div class="text-h6 mb-2">Activités</div>
      <ActiviteItem v-for="activite in inscription.list_activites.list" :key="activite.id"
        :all_activites="inscription.list_activites.list" :initial_commande_inscription="initial_commande_inscription"
        :item="activite" @updateQuantite="update_cart('activites')"></ActiviteItem>
    </div>
    <div v-if="inscription.list_articles.list.length > 0">
      <div class="text-h6 mb-2">Boutique</div>
      <ArticleItem v-for="article in inscription.list_articles.list" :key="article.id" :item="article"
        @updateQuantite="update_cart('articles')"></ArticleItem>
      <div class="text-h6 mb-2">Livraison</div>
      <ModeLivraison :infos="inscription.list_articles.infos_livraison" @updateMode="update_cart('articles')">
      </ModeLivraison>
    </div>
    <div>
      <CodeReductionItem class="mt-4" :item="inscription"></CodeReductionItem>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import OptionItem from "@/components/Inscription/Options/OptionItem.vue";
import InitialOptionItem from "@/components/FicheCoureur/Option_Item.vue";
import ActiviteItem from "@/components/Inscription/Options/ActiviteItem.vue";
import ArticleItem from "@/components/Inscription/Options/ArticleItem.vue";
import GIA from "@/components/Inscription/Options/GIA.vue";
import AlerteSMSItem from "@/components/Inscription/Options/AlerteSMSItem.vue";
import CodeReductionItem from "@/components/Inscription/Options/CodeReductionItem.vue";
import DonationItem from "@/components/Inscription/Options/DonationItem.vue";
import ModeLivraison from "@/components/Inscription/Options/ModeLivraison.vue";

export default {
  props: ["item", "initial_commande_inscription", "index_inscription"],
  components: { OptionItem, ActiviteItem, ArticleItem, GIA, DonationItem, CodeReductionItem, InitialOptionItem, ModeLivraison, AlerteSMSItem },
  data() {
    return {
      inscription: {},
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
    initialize() {
      this.inscription.set_finished(false);
      this.inscription.list_options.initialize_from_mainstore(this.mainStore.module.options.list);
      this.inscription.filter_availables_options();
      this.inscription.list_activites.initialize_from_mainstore(this.mainStore.module.activites.list);
      this.inscription.list_articles.initialize_from_mainstore(this.mainStore.module.articles_boutique.list);
      this.inscription.filter_availables_articles();
      const frais_livraison = this.mainStore.module.frais_livraison;
      this.inscription.list_articles.set_base_livraison_price(frais_livraison);
      const has_gia = this.mainStore.module.has_gia;
      this.inscription.initialize_gia(has_gia);
      const has_alerte_sms = this.mainStore.module.has_alerte_sms;
      this.inscription.initialize_alerte_sms(has_alerte_sms);
      this.inscription.donation.initialize_from_mainstore(this.mainStore.module.donation);
      this.update_cart("gia");


    },
    group_with_last(index) {
      if (index == 0) {
        return false;
      }
      if (this.inscription.list_options.list[index - 1].nom == this.inscription.list_options.list[index].nom) {
        return true;
      }
      return false;
    },
    update_cart(type) {

      this.inscription.update_cart(type, this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.bookingStore.compute_cart();
    },
  },
  async created() {
    this.inscription = this.item;
    this.initialize();
    //this.inscription.list_options.filter_availables(this.inscription);
    if (this.initial_commande_inscription) {
      this.inscription.list_options.filter_availables_for_changement_parcours();
    }
    this.update_cart("options");
  },
};
</script>

<style lang="scss" scoped></style>